<template>
  <div class="stock-detail-container">
    <div class="stock-detail-header">
      委托库存详情
    </div>
    <div class="stock-detail-content">
      <div class="batch-wrapper">
        <h3 class="title">
          批次流水详情
        </h3>
        <ul class="property">
          <li class="material-name">物料名称</li>
          <li class="material-code">物料编码</li>
          <li class="batch-number">批次号</li>
          <li class="quality">品项</li>
          <li class="test-quotation">检测报价</li>
          <li class="propertion">分成比例</li>
          <li class="stock-number">入库数</li>
          <li class="return-number">寄回数</li>
          <li class="sold-number">已售数</li>
          <li class="rent-number">已出租</li>
          <li class="inventory-number">当前库存</li>
          <!-- <li class="store-days">存放天数</li> -->
        </ul>
        <ul class="property-data" v-if="stockBatch">
          <li class="material-name">{{ stockBatch.itemName }}</li>
          <li class="material-code">{{ stockBatch.itemCode }}</li>
          <li class="batch-number">{{ stockBatch.batchCode }}</li>
          <li class="quality">
            <el-tag
              :type="stockBatch.itemQualityName | qualityType"
              size="mini"
            >
              {{ stockBatch.itemQualityName }}
            </el-tag>
          </li>
          <li class="test-quotation">{{ stockBatch.price }}</li>
          <li class="propertion">{{ stockBatch.scale }}</li>
          <li class="stock-number">{{ stockBatch.stockQuantity }}</li>
          <li class="return-number">{{ stockBatch.returnQuantity }}</li>
          <li class="sold-number">{{ stockBatch.soldQuantity }}</li>
          <li class="rent-number">{{ stockBatch.rentingQuantity }}</li>
          <li class="inventory-number">{{ stockBatch.quotaQuantity }}</li>
          <!-- <li class="store-days">{{ stockBatch.stockpileDay }}</li> -->
        </ul>
      </div>
      <div class="storage-wrapper">
        <h3 class="title">
          入库记录
        </h3>
        <el-table :data="stockRecords" size="mini" style="width: 100%">
          <el-table-column prop="itemName" label="物料名称" width="250">
          </el-table-column>
          <el-table-column prop="itemCode" label="物料编码" width="180">
          </el-table-column>
          <el-table-column prop="batchCode" label="批次号" width="180">
          </el-table-column>
          <el-table-column label="品项">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.itemQualityName | qualityType"
                size="mini"
              >
                {{ scope.row.itemQualityName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="检测报价" width="120">
          </el-table-column>
          <el-table-column prop="scale" label="分成比例" width="120">
          </el-table-column>
          <el-table-column prop="stockQuantity" label="入库数" width="120">
          </el-table-column>
          <el-table-column prop="createOn" label="入库时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.createOn | date }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" width="180">
          </el-table-column>
        </el-table>
      </div>
      <div class="sendback-wrapper">
        <h3 class="title">
          寄回记录
        </h3>
        <el-table :data="returnRecords" size="mini" style="width: 100%">
          <el-table-column prop="itemName" label="物料名称" width="250">
          </el-table-column>
          <el-table-column prop="itemCode" label="物料编码" width="180">
          </el-table-column>
          <el-table-column prop="batchCode" label="批次号" width="180">
          </el-table-column>
          <el-table-column label="品项">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.itemQualityName | qualityType"
                size="mini"
              >
                {{ scope.row.itemQualityName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="检测报价" width="120">
          </el-table-column>
          <el-table-column prop="scale" label="分成比例" width="120">
          </el-table-column>
          <el-table-column prop="sapPriceType" label="委托类型" width="150">
          </el-table-column>
          <el-table-column prop="returnQuantity" label="寄回数" width="120">
          </el-table-column>
          <el-table-column prop="rentTime" label="寄回时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.rentTime | date }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="sale-wrapper">
        <h3 class="title">
          售卖记录
        </h3>
        <el-table :data="saleRecords" size="mini" style="width: 100%">
          <el-table-column prop="itemName" label="物料名称" width="250">
          </el-table-column>
          <el-table-column prop="itemCode" label="物料编码" width="180">
          </el-table-column>
          <el-table-column prop="batchCode" label="批次号" width="180">
          </el-table-column>
          <el-table-column label="品项">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.itemQualityName | qualityType"
                size="mini"
              >
                {{ scope.row.itemQualityName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="检测报价" width="120">
          </el-table-column>
          <el-table-column prop="quantity" label="售卖数" width="120">
          </el-table-column>
          <el-table-column prop="totalAmount" label="金额" width="120">
          </el-table-column>
          <el-table-column prop="createOn" label="购买时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.createOn | date }}
            </template>
          </el-table-column>
          <el-table-column prop="payState" label="结算状态" width="120">
          </el-table-column>
          <el-table-column prop="payOn" label="结算时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.payOn | date }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="rent-wrapper">
        <h3 class="title">
          租赁记录
        </h3>
        <el-table :data="rentRecords" size="mini" style="width: 100%">
          <el-table-column prop="itemName" label="物料名称" width="250">
          </el-table-column>
          <el-table-column prop="itemCode" label="物料编码" width="180">
          </el-table-column>
          <el-table-column prop="batchCode" label="批次号" width="180">
          </el-table-column>
          <el-table-column label="品项">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.itemQualityName | qualityType"
                size="mini"
              >
                {{ scope.row.itemQualityName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="scale" label="分成比例" width="120">
          </el-table-column>
          <el-table-column prop="event" label="委托类型" width="150">
          </el-table-column>
          <el-table-column prop="rentQuantity" label="出租数" width="120">
          </el-table-column>
          <el-table-column prop="returnPrice" label="租赁单价" width="120">
          </el-table-column>
          <el-table-column prop="sum" label="金额" width="120">
          </el-table-column>
          <el-table-column prop="rentTime" label="租赁时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.rentTime | date }}
            </template>
          </el-table-column>
          <el-table-column prop="payState" label="结算状态" width="120">
          </el-table-column>
          <el-table-column prop="settlementTime" label="结算时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.settlementTime | date }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <div class="back-btn" @click="goBack">
          返回
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stockId: '',
      stockDetail: {},
      stockBatch: {},
      stockRecords: [],
      returnRecords: [],
      saleRecords: [],
      rentRecords: []
    }
  },
  beforeCreate() {
    this.$store.commit('setActiveIndex', '/indent')
    this.$store.commit('setSubActiveIndex', '/indent/stock')
    this.$store.commit('setAsideWidth', 300)
  },
  created() {
    this.stockId = this.$route.query.id
    this.getStockDetail(this.stockId)
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getStockDetail(id) {
      this.$http
        .get(`/api/services/inquiryApp/entrust/GetEntrustStock?`, { id: id })
        .then(res => {
          console.log(2112, res)
          this.stockDetail = res.result
          this.stockBatch = res.result.batch
          this.stockRecords = res.result.stockRecords
          this.returnRecords = res.result.returnRecords
          this.saleRecords = res.result.saleRecords
          this.rentRecords = res.result.rentRecords
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>
<style lang="less" scoped>
.stock-detail-container {
  width: 100%;
  min-width: 1200px;
  background-color: #ffffff;
  font-family: 'Source Han Sans CN';
  padding: 20px;
}
.stock-detail-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.stock-detail-content {
  .title {
    font-size: 14px;
    margin: 15px 0;
    font-weight: 600;
  }
  .property {
    padding: 0 20px;
    height: 45px;
    background-color: #f5f5f5;
    display: flex;
    align-items: center;
    font-size: 12px;
  }
  .property-data {
    padding: 0 20px;
    display: flex;
    align-items: center;
    height: 45px;
    font-size: 12px;
  }
  .batch-wrapper {
    border-bottom: 1px solid #ededed;
    .material-code {
      width: 10%;
    }
    .material-name {
      width: 20%;
    }
    .batch-number {
      width: 12%;
    }
    .quality {
      width: 10%;
      display: flex;
      align-items: center;
    }
    .test-quotation {
      width: 10%;
    }
    .propertion {
      width: 8%;
    }
    .stock-number,
    .return-number,
    .sold-number,
    .rent-number,
    .inventory-number {
      width: 8%;
    }
  }
}
.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.back-btn {
  width: 120px;
  height: 35px;
  margin-top: 20px;
  border-radius: 5px;
  text-align: center;
  line-height: 35px;
  border: 1px solid #b7bbc8;
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
}
</style>
